export default __webpack_public_path__ + "static/media/Sujata_Chavan.5a5b1d09.jpg";